import { createFileRoute, useLocation } from "@tanstack/react-router";
import { Link } from "react-aria-components";
import { button } from "@offsilo/ui/button";
import { Icon, IconHammer } from "@offsilo/ui/icon";
import { m } from "@/paraglide/messages.js";
import { usePageChrome } from "@/app/chrome";
import { activeHub, plannedPage } from "@/app/nav";

/** Any path in the plan that has no route file yet lands here, with its page id from docs/frontend/PAGES.md. */
export const Route = createFileRoute("/_app/$")({ component: Planned });

function Planned() {
  const { pathname } = useLocation();
  const page = plannedPage(pathname);
  const hub = activeHub(pathname);
  const label = page?.label() ?? pathname;
  usePageChrome([{ id: "hub", label: hub.label(), href: hub.href }, { id: "page", label }]);
  return (
    <div className="grid flex-1 place-items-center p-8">
      <div className="flex max-w-[440px] flex-col items-center gap-3 text-center">
        <span className="grid size-12 place-items-center rounded-xl bg-accent-subtle text-accent"><Icon icon={IconHammer} size="rail" /></span>
        <h1 className="font-title text-3xl">{m.planned_title()}</h1>
        <p className="text-md text-fg-muted">{m.planned_body({ page: page ? `${page.page} · ${label}` : label })}</p>
        <Link href="/home" className={button({ variant: "secondary" })}>{m.planned_back()}</Link>
      </div>
    </div>
  );
}
